/** @format */

import React, { Component } from "react";
import {
	Container,
	Row,
	Col,
	Breadcrumb,
	BreadcrumbItem,
	Card,
	CardHeader,
	CardBody,
	CardText,
	Form,
	FormGroup,
	Label,
	Input,
	FormText,
	Button,
} from "reactstrap";
import Loader from "../components/Loader";
import jquery from "jquery";
import 'react-notifications/lib/notifications.css';
import ReactNotification from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'
import 'animate.css/animate.min.css';
import 'animate.css/animate.compat.css'
import "animate.css"
import { store } from "react-notifications-component";
import { login } from "../global/url";
import {showNotification} from "../global/notification";
import { withRouter } from "react-router-dom";
import {
	setCookie,
	getCookie,
	eraseCookie,
	setLocalStorage,
	getLocalStorage,
	getUrlParam
  } from "../global/browserFunctions";




class Forgot extends Component {

	constructor(props) {
		super(props);
		var loggedin = getCookie("log");
		if (loggedin) this.GoToPage("/home"); // Check whether customer is logged in, if yes redirect to home
		this.state = { email: "" , loading: false};

		this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
		document.title = "Forgot Password";

	}
	GoToPage(path) {
		this.props.history.push(path); //Component has no access to history, so we pass from props
	  }

	handleChange(event) { //Handles change from multiple input
		var target = event.target;
		var name=target.name;
		var value=target.value
        this.setState({ [name]: value});
        
	}

	handleSubmit(event) {
		event.preventDefault();
        this.setState({ loading: true});
        var self=this;
        var email=this.state.email;
        var query="&email="+encodeURIComponent(this.state.email)+"&status=forgotpassword";

        jquery.ajax({ //request to change password
            url: login+query,
            dataType: 'jsonp',
            
            })
            .done(function(data){
				//console.log(data)
                data=JSON.parse(data);
                data=data[0];
				if(data.responseString=="SUCCESS"){
					self.setState({  loading: false });
					showNotification("Success!","success","An email has been sent to your registered email with reset password link");
					setTimeout(
						function() {
							self.GoToPage("/");
						}
						.bind(this),
						2000
					);
				}
				else{
					self.setState({  loading: false });
					showNotification("Information!","warning", "You're not signed up yet. Please signup");
				}
			})
        }
                
	render() {
		return (
            
			<React.Fragment>
                
            <section className="pb-5">
                <Container>
                
                    <Row className="abc">
                        <Col lg="8">
                        <Loader loading={this.state.loading}/>
                            <Card>
                                <CardHeader className="py-4 px-5">
                                    <h5 className="mb-0">Forgot Password</h5>
                                </CardHeader>
                                <CardBody className="p-5">
                                    
                                    
                                    <Form onSubmit={this.handleSubmit}>
                                        <FormGroup>
                                            <Label className="form-label" for="emailLogin" >Email</Label>
                                            <Input
									id='emailLogin'
									name='email'
									type='text'
									onChange={this.handleChange}
									value={this.state.email}
									pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$'
									required
								/>
                                        </FormGroup>
                                       
                                       
                                        <Button color="dark" type="submit" onClick={this.addNotification} ><i className="fa fa-sign-in-alt mr-2"  /> Submit</Button>
                                       
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                        
                    </Row>
                </Container>
            </section>
        </React.Fragment>
		);
	}
}

export default Forgot;